// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__13BbX","section":"styles_section__3IcVV","head":"styles_head__16n66","footer":"styles_footer__fowyg","form":"styles_form__2VwlH"};